var map = {
	"./barber-logo-white.png": "Nua3",
	"./barber-logo.png": "ghQQ",
	"./barber-portrait.jpg": "TA1P",
	"./gatsby-astronaut.png": "CgFe",
	"./gatsby-icon.png": "KTxw",
	"./icons/beard.svg": "KKSl",
	"./icons/chevron.svg": "FLYv",
	"./icons/cut-scissor.svg": "8yv2",
	"./icons/hair-comb.svg": "WB0L",
	"./icons/hairdryer.svg": "C0Wz",
	"./icons/maps-line.svg": "6/1C",
	"./icons/no-photo.svg": "O3Lx",
	"./main-header-00.jpg": "K49B",
	"./main-header-01.jpg": "B3qB",
	"./salons/interior00.jpg": "3x2e",
	"./salons/interior01.jpg": "yjWj",
	"./store-owner.jpg": "Qagk"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "shgI";